module.exports = __webpack_public_path__ + "img/3.d4585174.jpg";